/**
 * Mention « Affinicar Assist » Oui / Non.
 *
 * Partagée par la colonne de la liste des garanties et la vignette de choix de
 * garantie, pour que les deux écrans disent la même chose de la même façon.
 *
 * N'inclut PAS le badge « Assist » de la liste des contrats : celui-ci est un
 * marqueur court dans une colonne étroite, déjà en place, et il reste tel quel.
 */
interface AssistanceBadgeProps {
  /** La garantie ou le contrat porte-t-il une formule ? */
  hasAssistance: boolean;
  /** Libellé de la formule, affiché en infobulle quand il est connu. */
  formulaLabel?: string | null;
}

export function AssistanceBadge({ hasAssistance, formulaLabel }: AssistanceBadgeProps) {
  return (
    <span
      className={`tw-px-2 tw-py-0.5 tw-text-xs tw-rounded-full tw-font-medium tw-whitespace-nowrap ${
        hasAssistance
          ? 'tw-bg-affinicar-lighter tw-text-affinicar-secondary'
          : 'tw-bg-gray-100 tw-text-gray-500'
      }`}
      title={hasAssistance ? (formulaLabel ?? undefined) : undefined}
    >
      {hasAssistance ? 'Oui' : 'Non'}
    </span>
  );
}
